<template>

    <SubHeader title="Liste des profils" :breads="[{ name: 'Profiles' }]" :action="{}" />
    <Modal @handle-submit="submitModal">


        <div class="mb-3 ">
            <label class="form-label" for="type"><b>Role</b> </label>
            <input type="text" required v-model="data.name" class="form-control" placeholder="Nom du role" />
        </div>
        <div class="mb-3">
            <label class="form-label" for="type"><b>Permissions</b> </label>
            <div class="row">
                <div class="col-3 mt-1" v-for="(entite, i) in permissionItems " :key="i">
                    <div class="row">
                        <div class="col form-check">
                            <input type="checkbox" @change="addManyOrRemoveManyPermission(entite.id)"
                                class="form-check-input" :id="`check_${i}`" />
                            <label :for="`check_${i}`">
                                <b class="ml-3">{{ entite.description }}</b>
                            </label>
                        </div>
                    </div>
                    <div class="row mx-2">
                        <ul style="text-decoration: none; list-style-type: none;">
                            <li v-for="(permission, j) in entite.permissions" :key="j">
                                <div class="row">
                                    <div class="col form-check">
                                        <input type="checkbox" @change="addOrRemovePermission(permission.id)"
                                            :checked="data.permissions.includes(permission.id)" class="form-check-input"
                                            :id="`permission_check_${permission.id}`" />
                                        <label :for="`permission_check_${permission.id}`"> {{ permission.label
                                            }}</label>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>


        <template #btn>

            <button type="button" :disabled="createIsLoading || updateIsLoading" class="btn btn-primary"
                @click="submitModal">
                <span v-if="createIsLoading || updateIsLoading" class="spinner-grow" role="status">
                    <span class="visually-hidden">Loading...</span>
                </span>
                <span v-else>
                    {{ formUpdate ? "Modifier" : "Enregistrer" }}
                </span>
            </button>


        </template>
    </Modal>
    <div class="card">
        <div class="card-header">
            <button type="button" class="btn btn-outline-primary btn-xs" @click="this.toggleModal = true">
                <i class="bi bi-plus me-1"></i> Ajouter
            </button>
        </div>
        <div class="card-body datatable-custom position-relative table-responsive">
            <data-table :rows="items" :columns="cols" :loading="isLoading" :sortable="true" sortColumn="id"
                sortDirection="desc" paginationInfo="De {0} à {1} sur un total de {2}" :search="searchWord"
                noDataContent="Pas de resultat"
                class="advanced-table whitespace-nowrap table table-borderless table-thead-bordered ">
                <template #permissions="{ value }">
                    <div>
                        <span class="badge bg-soft-dark text-black mx-2 mt-1"
                            v-for="(permission, i) in value.permissions" :key="i">
                            {{ permission.description }}
                        </span>
                    </div>
                </template>
                <template #action="{ value }">
                    <div class="btn-group" role="group" aria-label="Button group with nested dropdown">

                        <!-- a href="" class="btn btn-outline-dark btn-xs" title="Voir le résumé"><i class="bi bi-eye"></i></a -->
                        <span @click="getProfil(value.id)" class="btn btn-outline-dark btn-xs" title="Voir la fiche">
                            <i class="bi bi-eye"></i>
                        </span>
                    </div>
                </template>
            </data-table>
        </div>
    </div>






</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import Modal from "@/widgets/Modal.vue"


export default {
    name: " CreateUserProfile",
    components: {
        SubHeader,
        Modal
    },
    data() {
        return {
            
            cols: [
                { field: 'id', title: '', sort: false, width: '0px', type: 'number', cellRenderer() { return "" } },
                { field: 'name', title: 'Role' },
                { field: 'permissions', title: 'Permissions' },
                { field: 'action', title: 'Actions', sort: false, width: '10px', headerClass: 'justify-center', cellClass: 'justify-center' },
            ],
            searchWord: null,
            data: {
                id: null,
                permissions: [],
                permissionselect: [],
                label: null
            },
            formUpdate: false,

        }

    },
    computed: {
        ...mapFields("profil/list", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",
            items: "items"
        }),
        ...mapFields("widget/modal", {

            toggleModal: 'showMessage'

        }),
        ...mapFields("profil/show", {
            showIsLoading: "isLoading",
            showIsSuccess: "isSuccess",
            showShowMessage: "showMessage",
            showMessage: "message",
            showItems: "item"
        }),
        ...mapFields("profil/create", {
            createIsLoading: "isLoading",
            createIsCreated: "isCreated",
            createIsSuccess: "isSuccess",
            createShowMessage: "showMessage",
            createMessage: "message",
            createItems: "create"
        }),
        ...mapFields("profil/update", {
            updateIsLoading: "isLoading",
            updateIsUpdated: "isUpdated",
            updateIsSuccess: "isSuccess",
            updateShowMessage: "showMessage",
            updateMessage: "message",
            updateItems: "update"
        }),

        ...mapFields("permission/list", {
            permissionIsLoading: "isLoading",
            permissionIsSuccess: "isSuccess",
            permissionShowMessage: "showMessage",
            permissionMessage: "message",
            permissionItems: "items"
        }),
    },
    methods: {
        ...mapActions({
            getProfils: "profil/list/getAll",
            getProfil: "profil/show/getOne",
            createProfil: "profil/create/create",
            updateProfil: "profil/update/update",
            resetUpdateProfil: "profil/update/resetData",
            resetCreateProfil: "profil/create/resetData",
            getPermissions: "permission/list/getAll",
            reset: "profil/list/resetData",
            resetPermissions: "permission/list/resetData",
        }),
        submitModal() {
            if (this.formUpdate) {
                this.updateProfil(this.data)
            } else {
                this.createProfil(this.data)
            }
        },
        addOrRemovePermission(id) {
            if (this.data.permissions.includes(id)) {
                this.data.permissions.splice(this.data.permissions.indexOf(id), 1)
            } else {

                this.data.permissions.push(id)
            }
        },
        addManyOrRemoveManyPermission(id) {
            const role = this.permissionItems.find((r) => r.id == id);
            if (role) {
                var removeAction = false;
                role.permissions.forEach((perm, i) => {
                    if (i == 0) {
                        removeAction = this.data.permissions.includes(perm.id)
                    }
                    if (removeAction) {
                        this.data.permissions.splice(this.data.permissions.indexOf(perm.id), 1)
                    } else {
                        if(!this.data.permissions.includes(perm.id)){

                            this.data.permissions.push(perm.id)
                        }

                    }

                })
            }

        }

    },
    watch: {


        showItems(val) {
            if (this.showIsSuccess) {
                this.formUpdate = true;
                this.toggleModal = true;
                this.data.permissions = val?.permissions.map((s)=>s.id) ?? [];
                this.data.name = val?.name ?? " ";
                this.data.id = val?.id ?? null
            } else {
                this.formUpdate = false;
                this.toggleModal = false;
                this.data.permissions = [];
                this.data.name = " ";
                this.data.id = null
            }
        },
        createIsCreated(val) {
            if (val) {
                this.resetCreateProfil()
                this.getProfils()
                this.getPermissions()
                this.toggleModal = false;

            }
        },
        updateIsUpdated(val) {
            if (val) {
                this.resetUpdateProfil()

                this.reset()
                this.getProfils()
                this.getPermissions()
                this.toggleModal = false;

            }
        },
        toggleModal(val) {
            if (!val) {

                this.formUpdate = false;
                this.toggleModal = false;
                this.data.permission = [];
                this.data.name = " ";
                this.data.id = null

            }

        }
    },
    mounted() {
        this.getProfils()
        this.getPermissions()
    },
    unmounted() {
        this.reset()
        this.resetPermissions()
    }
}
</script>
